let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("9BiZd")]).then(() => parcelRequire('jJF0P'));